import { replaceUnderScoreAddSpace } from "../../utils/utils";
import {
  checkNull,
  KeyValPair,
  ListContent,
  ReportContainer,
} from "../constant";

interface VaccinesBlockProps {
  data: any;
}

const VaccinesBlock = ({ data }: VaccinesBlockProps) => {
  if (!checkNull(data?.patientVaccines)) return null;

  return (
    <ReportContainer label="Immunizations" flow>
      <ListContent
        list={data?.patientVaccines}
        renderItem={(item) => (
          <KeyValPair
            k={item?.vaccine?.name ?? "-"}
            v={`${item?.dose || ""} ${item?.units || ""} ${
              item?.route
                ? "by " +
                  replaceUnderScoreAddSpace(item.route?.toLocaleLowerCase())
                : ""
            } ${
              item?.site
                ? "on " + replaceUnderScoreAddSpace(item?.site?.toLowerCase())
                : ""
            }`}
          />
        )}
      />
    </ReportContainer>
  );
};

export default VaccinesBlock;
